import { render, staticRenderFns } from "./AdminAlertInsuranceTypeList.vue?vue&type=template&id=c3bddfb0"
import script from "./AdminAlertInsuranceTypeList.vue?vue&type=script&lang=js"
export * from "./AdminAlertInsuranceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports